import { render } from "./AdminBookingsLog.vue?vue&type=template&id=378b0d5c"
import script from "./AdminBookingsLog.vue?vue&type=script&lang=js"
export * from "./AdminBookingsLog.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__